<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Cкрининг light</span>
        <el-button class="box-header__button" size="mini" @click="addItem" type="primary">Добавить</el-button>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column prop="title" label="Название">
            <template slot-scope="scope">
              <el-link type="primary" @click="editItem(scope.row.id)">
                {{
                scope.row.registration_date
                }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Редактировать" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="editItem(scope.row.id, scope.row)"
                />
              </el-tooltip>
              <el-tooltip content="Удалить прибор" placement="top">
                <el-popconfirm
                  class="confirmBtn"
                  @onConfirm="deleteItem(scope.row.id, scope.$index)"
                  title="Вы уверены?"
                  confirmButtonText="Да"
                  confirmButtonType="danger"
                  cancelButtonType="default"
                  cancelButtonText="Нет"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    slot="reference"
                    type="danger"
                  />
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'light',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      Item: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      selectItem: false,
      addModal: false,
      editModal: false
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  components: { },
  methods: {
    loadLogic () {
      this.$api.users
        .getList()
        .then((response) => {
          this.tableData = response.data.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    editItem (id) {
      this.selectItem = id

      this.editModal = !!1
    },
    addItem () {
      this.addModal = !!1
    },
    deleteItem (id, idIndex) {
      this.loading = !!1
      this.$api.worker
        .delete(id)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.tableData.splice(idIndex, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка авторизации',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}
</style>
